/* * * * * * * * * * * * * * * * *
 * Monmouth University MapBox App
 *  - MU MarComm
 * * * * * * * * * * * * * * * * */


/* * 
 * Sec.A: Essential Variables and Functions 
 * */

// API KEY
mapboxgl.accessToken = 'pk.eyJ1IjoibW9ubW91dGh1bml2ZXJzaXR5IiwiYSI6ImNqNWNqbzhiazBiM3kycW1uMXIxaXdmZ2cifQ.IgRg2d6Ie8aK_xuIe6L0EQ';

/* Helper Functions
 * */

/* Functions to handle the existence, addition, and removal of classes
 * from a chosen element.
 * */
function hasClass(el, classname) {
	return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

function addClass(el, classname) {
	el.className += " " + classname;
}

function removeClass(el, classname) {
	el.className = el.className.replace(" " + classname, "");
	el.className = el.className.replace(classname, "");
}

/* Functions to hide and reveal elements with plain js
 * */
function hideIt(el) {
	if (!hasClass(el, 'hidden')) {
		addClass(el, 'hidden');
	}
}

function revealIt(el) {
	if (hasClass(el, 'hidden')) {
		removeClass(el, 'hidden');
	}
}

/* Function to trigger an event on a chosen element
 * Source: https://plainjs.com/javascript/events/trigger-an-event-11/
 * */
function triggerEvent(el, type) {
	var e;
	if ('createEvent' in document) {
		// modern browsers, IE9+
		e = document.createEvent('HTMLEvents');
		e.initEvent(type, false, true);
		el.dispatchEvent(e);
	} else {
		// IE 8
		e = document.createEventObject();
		e.eventType = type;
		el.fireEvent('on' + e.eventType, e);
	}
}

/* Function to safely parse HTML into DOM
 */
function HTMLParser(str) {
	var theParser = new DOMParser();
	var theDom = theParser.parseFromString(
		'<!doctype html><body>' + str + '</body>',
		'text/html');
	return theDom.body.textContent;
}

/* Function to create Categorial Auto Complete 
 */
function catCompleteCreate() {
	jQuery.widget("custom.catcomplete", jQuery.ui.autocomplete, {
		_create: function () {
			this._super();
			this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
			this._on(this.element, {
				focus: function (event) {
					this.search();
				}
			});
		},
		_renderMenu: function (ul, items) {
			var that = this,
				currentCategory = "";
			jQuery.each(items, function (index, item) {
				var li;
				if (item.category != currentCategory) {
					ul.append("<li class='ui-autocomplete-category categoryHeader'>" + item.category + "</li>");
					currentCategory = item.category;
				}
				li = that._renderItemData(ul, item);
				if (item.category) {
					li.attr("aria-label", item.category + " : " + item.label);
				}
			});
		}
	});
}
catCompleteCreate();

/* Common Elements
 * */

var theMap = document.getElementById('map');
var mapMenu = document.getElementById('map-menu');
var mapCanvas = document.getElementById('map-canvas');
var searchInp = document.getElementById('searchInp');
var clearBtn = document.getElementById('clearBtn');
var errorDiv = document.getElementById('errorDiv');
// Div where initial list of locations appears
var listDiv = document.getElementById('locationDiv');
// Div that houses search results / error msgs
var searchDiv = document.getElementById('searchDiv');
// Div where search results appear
var resultsDiv = document.getElementById('searchResults');
// direction elements
/*
var dirFromInp = document.getElementById('dirFrom');
var dirToInp = document.getElementById('dirTo');
*/


// stylesheet directory
var stylesheetDir = directory_uri.url;
/* Counters
 * */
var scrolledUp = true;
var oldWidth = 0;
var oldHeight = window.innerHeight;

/* ID ORDER
 * 'Leon Hess Business School',
 * 'Marjorie K. Unterberg School of Nursing and Health Studies',
 * 'School of Education',
 * 'School of Science',
 * 'School of Social Work',
 * 'Wayne D. McMurray School of Humanities and Social Sciences',
 * 'Graduate Studies',
 * 'Honors School' 
 * */

/* *
 * Sec.B: Location Collection
 * */

var restAPI = document.querySelector("link[rel='https://api.w.org/']").getAttribute("href");

// Create a new Collection for the locations on the map, then instantiate
var Locations = Backbone.Collection.extend({
	url: restAPI + "map/v1/location",
	sort_key: 'id',
	comparator: function (item) {
		return item.get(this.sort_key);
	},
	sortByField: function (fieldName) {
		this.sort_key = fieldName;
		this.sort();
	},
	getGeoJSON: function (type) {
		if (!type) type = "geooutline";
		geojson = {
			"type": "FeatureCollection",
			"features": []
		};
		this.forEach(function (location) {
			var locationGeoJSON = {};
			if (type == "geooutline" && location.has("geooutline")) {
				geooutline = location.get("geooutline");
				geooutline.push(location.get("geooutline")[0]);
				locationGeoJSON = {
					"type": "Feature",
					"properties": {
						"id": location.id,
						"p_id": location.p_id,
					},
					"geometry": {
						"coordinates": [
							_.map(geooutline, function (cords) {
								return [cords.lng, cords.lat];
							})
						],
						"type": "Polygon"
					}
				};
				geojson.features.push(locationGeoJSON);
			} else if (type == "point" && location.has('location') && !location.has('geooutline')) {
				locationGeoJSON = {
					"type": "Feature",
					"properties": {
						"id": location.id,
						"title": location.get('name'),
						"icon": "marker"
					},
					"geometry": {
						"type": "Point",
						"coordinates": [location.get('location').longitude, location.get('location').latitude]
					}
				};
				geojson.features.push(locationGeoJSON);
			}
		});
		return geojson;
	},
});
var locations = new Locations(JSON.parse(locations_uri.uri.body));
locations.sortByField('name');

// grab all location category names
var catNames = [];
for (var i = 0; i < categories.cats.length; i++) {
	catNames.push(categories.cats[i].name);
}

// _.each(locations.models, function(obj){
// 	var theOption = document.createElement('option');
// 	theOption.setAttribute('value', obj.get('id'));
// 	theOption.innerText = obj.get('name');

// 	var opClone = theOption.cloneNode(true)

// 	dirFromSel.appendChild(theOption);
// 	dirToSel.appendChild(opClone);
// })

var locSels = [];
_.each(locations.models, function (obj) {
	var map_types = obj.get('map_type');
	if (map_types) {
		for (var i = 0; i < map_types.length; i++) {
			if (catNames.indexOf(map_types[i].name) != -1) {
				var theOption = {
					value: obj.get('name'),
					label: obj.get('name'),
					category: map_types[i].name,
				};
				locSels.push(theOption);
			}
		}
	}
});

jQuery('#dirFrom').catcomplete({
	source: locSels,
	minLength: 2,
	select: function (event, ui) {
		jQuery(this).val(ui.item.value);
		return false;
	}
});

jQuery('#dirTo').catcomplete({
	source: locSels,
	minLength: 2,
	select: function (event, ui) {
		jQuery(this).val(ui.item.value);
		return false;
	}
});

// create the options for dirTo and dirFro

/* *
 * Sec.C: Collections for Departments, and Offices and Services
 * */
/*var Offices = Backbone.Collection.extend({
	url: restAPI + 'wp/v2/office?per_page=100',
})*/
var offices = new Backbone.Collection(JSON.parse(offices_uri.uri.body));
var depts = new Backbone.Collection(JSON.parse(depts_uri.uri.body));
//console.log(depts);
//console.log(offices);

// priority by name
var s_priority = ['Leon Hess Business School', 'Marjorie K. Unterberg School of Nursing and Health Studies', 'School of Education', 'School of Science', 'School of Social Work', 'Wayne D. McMurray School of Humanities and Social Sciences', 'Graduate Studies', 'Honors School'];

// convert priority to id based the departments grabbed
_.each(depts.models, function (obj) {
	if (!obj.has("schools")) {
		return;
	}
	var theIndex = s_priority.indexOf(obj.get('schools')[0].name);
	if (theIndex != -1) {
		s_priority[theIndex] = obj.get('schools')[0].term_id;
	}
});
//console.log(s_priority)

/* *
 * Sec.C: The Map's Model
 * */

var CampusMap = Backbone.View.extend({
	// Map specifics
	el: "#map",
	$infoHeader: null,
	$infoBody: null,
	collection: locations,
	depts: depts,
	offices: offices,
	map: false,
	mapinitialized: false,
	styleLoaded: false,
	fbPadding: 20,
	fbOffset: [0, 0],
	searchCatNum: 3,
	priorityMax: function () {
		return this.searchCatNum + 2;
	},
	mapOptions: {
		container: 'map-canvas',
		style: 'mapbox://styles/monmouthuniversity/cj5cjr6vn06gy2ro78nfto67c',
		center: [-74.0052, 40.2787],
		zoom: 15.99,
		//pitch: 0,
		//bearing: 40
		offset: self.fbOffset,
	},
	// store what modal window user is/was looking at
	windows: {
		// options: main, details, directions
		current: "main",
		last: "",
	},
	// store id of what location user is looking at
	curLocation: "",

	// Initialize method
	initialize: function () {
		var self = this;
		self.$infoHeader = self.$el.find("#map-menu-location-title");
		self.$infoBody = self.$el.find("#map-menu-location-body");
	},

	render: function () {
		var self = this;
		self.map = new mapboxgl.Map(this.mapOptions);
		self.map.on('style.load', function () {
			self.styleLoaded = true;
			self.addPOI();
			self.setGeoLocation();
			self.mapinitialized = true;
		});
		self.map.on('load', function () {
			self.addMUAttr();
		});
	},

	// Map Events
	events: {
		// "click #map-menu-location-title": "hideLocation",
		"click .map-menu #backToMain": "hideLocation",
		"click #dirBtn": "clickDirBtn",
		"click button#dirSearch": "clickDirSearch",
		"click #dirSwitch": "clickDirSwitchBtn",
		"hover .map-menu-body .sidebarSel": "previewLocation",
		"click .sidebarSel": "clickSidebarSel",

	},

	/* All Other methods sorted a-z */


	addPOI: function () {
		/* addPOI: Adds all points of interest by grabbing data 
		 * from the location collection we generated in Section B
		 * */
		var self = this;
		self.map.addLayer({
			'id': 'theBordersActive',
			'type': 'fill',
			'source': {
				'type': 'geojson',
				'data': self.collection.getGeoJSON()
			},
			'layout': {},
			'paint': {
				'fill-color': '#002855',
				'fill-opacity': 0.4
			},
			"filter": ["==", "id", ""]
		});
		self.map.addLayer({
			'id': 'theBuildings',
			'type': 'fill',
			'source': {
				'type': 'geojson',
				'data': self.collection.getGeoJSON()
			},
			'layout': {},
			'paint': {
				'fill-color': '#088',
				'fill-opacity': 0
			}
		});
		self.map.addLayer({
			'id': 'thePointLocations',
			'type': 'symbol',
			'source': {
				'type': 'geojson',
				'data': self.collection.getGeoJSON("point")
			},
			'layout': {
				"icon-image": "{icon}-15",
				//"text-field": "{title}",
				//"text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Regular"],
				//"text-offset": [0, 0.6],
				//"text-anchor": "top",
				//"text-size": 12.63,
			}
		});

		// directions layer
		/*
		self.map.addSource('directions', {
			"type": "geojson",
			"data": null
		});
		self.map.addLayer({
			"id": "theDirections",
			"type": "line",
			"source": 'directions',
			"layout": {
				"line-join": "round",
				"line-cap": "round"
			},
			"paint": {
				"line-color": "#004c97",
				"line-width": 8,
				"line-opacity": 0.75,
			}
		})
		*/
		// This function focuses the map onto any location selected by the user
		function locFocus(e) {
			var wOffset = window.pageYOffset;
			if (self.isMobile()) {
				jQuery('html, body').animate({
					scrollTop: (window.innerHeight * 0.4)
				}, 800);
				self.setBoundingOffset(window.innerHeight * 0.4);
			} else {
				self.setBoundingOffset(wOffset);
			}
			mapapp.navigate("location/" + e.features[0].properties.id, {
				trigger: true
			});
		}
		// The app calls locFocus() whether the user clicks a point or a building
		self.map.on('click', 'thePointLocations', function (e) {
			locFocus(e);
		});
		self.map.on('click', 'theBuildings', function (e) {
			locFocus(e);
		});
		//return true;
	},
	addMUAttr: function () {
		var self = this;
		var muHTML = "<div class='muAttr'><a href='https://www.mapbox.com/about/maps/'>Location Descriptions &copy; Monmouth University</a></div>";
		var muNode = document.createRange().createContextualFragment(muHTML);
		// attrNode
		var parentNode = document.getElementsByClassName('mapboxgl-ctrl-bottom-left')[0];
		parentNode.insertBefore(muNode, parentNode.childNodes[1]);
	},

	buildingHTML: function (catModel) {
		/* buildingHTML: creates a link for the location sidebar.
		 * Par: catModel - a categorical search result (see searchLocs())
		 * */
		var self = this;
		var theHTML = "<p><button class='sidebarSel' data-location='" + catModel.id + "'>" + this.collection.get(catModel.id).attributes.name + "</button></p>";
		return theHTML;
	},
	clearResults: function () {
		/* clearResults: clears the location sidebar of all search results.
		 * Does this simulating the clearance of the search input with backspaces
		 * */
		var self = this;
		searchInp.value = "";
		triggerEvent(searchInp, 'keyup');
	},
	formatResults: function (rList) {
		/* formatResults: create the HTML to display the search results,
		 * listing each of them by priority.
		 * 
		 * Par: rList - the search results list
		 * */
		var self = this;
		var resultHTML = "";
		var priorityHTML = [];
		for (var i = 0; i < self.priorityMax(); i++) {
			priorityHTML[i] = "";
		}
		_.each(rList, function (obj) {
			priorityHTML[obj.priority] += self.buildingHTML(obj);
		});
		for (var i = 0; i < self.priorityMax(); i++) {
			resultHTML += priorityHTML[i];
		}
		return resultHTML;
	},
	/*
	directions: {
		/* directions: a map property that holds 
		 * the map's latest travel directions
		 * */

	/*
   revealed: false,
   orig: 0,
   dest: 0,
   url: restAPI + "map/v1/directions",
   directions: new Object(),
   getDirections: function() {
	   var self = this;
	   // form the calling url
	   var theCall = self.url + "/" + self.orig + "/" + self.dest;
	   console.log(theCall);
	   // grab the directions
	   var directionsXHR = new XMLHttpRequest();
	   directionsXHR.open('GET', theCall, true);
	   directionsXHR.send();

	   // Response functions
	   function transferComplete() {
		   // log the directions
		   var theDirections = JSON.parse(this.responseText);	
		   console.log(theDirections)			
		   self.visualDirections(theDirections);
		   //self.writtenDirections(theDirections);
	   }
	   function transferFailed(){
		   console.log(this.responseText);
	   }
	   directionsXHR.onload = transferComplete;
	   directionsXHR.onerror = transferFailed;
   },
   visualDirections: function(directions) {
	   // Add the directions to the direction layer 
	   var theGeo = directions.routes[0].geometry;
	   var theData = {
		   "type": "Feature",
		   "properties": {},
		   "geometry": theGeo
	   }
	   campusmap.map.getSource('directions').setData(theData);
   },
   writtenDirections: function(directions) {
	   /* grab each written direction and format all of them
	   into the HTML of written dirs */
	// var theHTML = "<h3>Route</h3>";
	// var steps = directions.routes[0].legs[0].steps;
	// //console.log(steps);
	// for (var i = 0; i < steps.length; i++) {
	// 	theHTML += "<p>" + (i+1) + ". " + 
	// 	HTMLParser(steps[i].maneuver.instruction) + ", "
	// 	(steps[i].distance * 3.28084) + " feet"
	// 	+ "</p>";
	// }
	// document.getElementById('directionResults').innerHTML = theHTML;
	/*
}
},
*/
	/*
	directionTest: function(){
		var self = this;
		self.directions.orig = 110;
		self.directions.dest = 25;
		self.directions.getDirections();
		console.log(self.directions.url)
	},
	*/
	clickSidebarSel: function (e) {
		var self = this;
		var wOffset = window.pageYOffset;
		if (self.isMobile()) {
			jQuery('html, body').animate({
				scrollTop: (window.innerHeight * 0.4)
			}, 800);
			self.setBoundingOffset(window.innerHeight * 0.4);
		} else {
			self.setBoundingOffset(wOffset);
		}
		mapapp.navigate("location/" + e.target.getAttribute('data-location'), {
			trigger: true
		});

	},
	displayResults: function () {
		/* displayResults: grabs search input and display results on page
		 * */
		var self = this;
		var searchVal = searchInp.value.trim();
		var searchList = [];
		var searched = false;
		// grab the input 
		var i_search = {
			value: searchVal
		};
		if (i_search.value.trim().length > 0) {
			// search the map
			searchList = campusmap.searchLocs(i_search.value);
			searched = true;
		}
		// display search results if found
		if (searchList.length > 0) {
			resultsDiv.innerHTML = campusmap.formatResults(searchList);
			// toggle classes
			hideIt(listDiv);
			hideIt(errorDiv);
			revealIt(searchDiv);
			revealIt(resultsDiv);
			revealIt(clearBtn);
		}
		// display not found message when no results
		else if (searched) {
			hideIt(listDiv);
			hideIt(resultsDiv);
			revealIt(searchDiv);
			revealIt(errorDiv);
			revealIt(clearBtn);
		}
		// if no value to search, make sure init menu displays
		else {
			hideIt(errorDiv);
			hideIt(searchDiv);
			hideIt(resultsDiv);
			hideIt(clearBtn);
			revealIt(listDiv);
		}
	},
	geoLocation: {
		/* geoLocation: property handles the geoLocation control
		 * */
		status: false,
		control: {}
	},

	hideLocation: function () {
		/* hideLocation: hides the border of a location
		 * */
		var self = this;
		self.map.setFilter('theBordersActive', ['==', 'id', '']);
		self.$el.removeClass("show-details");
		self.windowSwitcher('main');
		self.map.flyTo({
			center: self.mapOptions.center,
			zoom: self.mapOptions.zoom,
			offset: self.fbOffset,
		});

	},
	isMobile: function () {
		/* isMobile: detects whether page is mobile or not.
		 * Based on width of the theMap, ensuring that mobile status
		 * matches the same 100vw value observed by CSS
		 * */
		var self = this;
		var rect = theMap.getBoundingClientRect();
		if (rect.width < 768) {
			return true;
		} else {
			return false;
		}
	},
	previewLocation: function (location) {
		/* previewLocation: highlights a building 
		 * when user hovers over a location
		 * */
		var self = this;
		if (!this.mapinitialized || this.collection.models.length == 0) return false;
		if (location.type == "mouseenter") {
			location = location.target.getAttribute('data-location');
			self.map.setFilter('theBordersActive', ['==', 'id', location]);
		}
	},
	searchLocs: function (searchKey) {
		/* searchLocs: Keyword search through building names and building codes
		 *
		 * Par: searchKey - the keyword to search
		 * */
		// RegEx tester for keywords, ignoring case
		var self = this;
		var tester = new RegExp(searchKey, 'i');

		// strings for precise bCode tester
		var oneR = '^' + searchKey + '$';
		var firstR = '^' + searchKey + ',';
		var middleR = ', ' + searchKey + ',';
		var lastR = ', ' + searchKey + '$';
		var precR = oneR + '|' + firstR + '|' + middleR + '|' + lastR;
		var precTester = new RegExp(precR, 'i');

		// new model type for search
		function r_Model(theId, r_cats, r_clips) {
			// string, array, int
			this.id = theId;
			this.cats = r_cats;
			this.clips = r_clips;
			this.priority = null;
			if (this.cats.indexOf('preciseBCode') != -1) {
				this.priority = 0;
			} else if (this.cats.indexOf('name') != -1 && this.cats.indexOf('bCode') != -1) {
				this.priority = 1;
			} else if (this.cats.indexOf('name') == -1 && this.cats.indexOf('bCode') != -1) {
				this.priority = 2;
			} else {
				this.priority = 3;
			}
		}
		var newList = [];
		_.each(self.collection.models, function (obj) {
			var r_cats = [];
			var r_clips = [];
			var pos = null;
			// Step 1: Name 
			// name
			if (pos = tester.exec(obj.attributes.name)) {
				r_cats.push('name');
				r_clips.push("");
			}
			// Part 2: If nothing, let's check building codes
			// First check if input is a precise bCode (no fluff)
			if (pos = precTester.exec(obj.attributes.building_code)) {
				r_cats.push('preciseBCode');
				r_clips.push('');
			}
			// otherwise, test for a possible imprecise match
			else if (pos = tester.exec(obj.attributes.building_code)) {
				r_cats.push('bCode');
				r_clips.push('');
			}
			if (r_cats.length > 0) {
				// add new result
				newList.push(new r_Model(obj.id, r_cats, r_clips));
			}
		});
		return newList;
	},
	setBoundingOffset: function (wScroll) {
		/* setBoundingOffset: changes the vertical offset based on scroll pos
		 *
		 * Par: wScroll - an int representing the scroll pos 
		 *                that will serve as the basis for the offset.
		 * */

		var self = this;
		// if mobile, no offset
		if (!self.isMobile()) {
			self.fbPadding = 100;
			self.fbOffset = [0, 0];
		} else {
			// grab height of canvas, find virtual height from scroll pos - header size
			var rect = mapCanvas.getBoundingClientRect();
			var theDif = rect.height - (rect.height - wScroll);

			// offset is virtual height / 2
			var bNum = theDif / 2;
			self.fbPadding = 20;
			self.fbOffset = [0, bNum];
		}
	},
	setGeoLocation: function () {
		/* setGeoLocation: creates a geoLocation property 
		 * based on whether viewbox is a mobile width.
		 * */
		var self = this;
		if (self.geoLocation.status != false) {
			self.map.removeControl(self.geoLocation.control);
		}
		if (self.isMobile()) {
			self.geoLocation.control = new mapboxgl.GeolocateControl({
				positionOptions: {
					enableHighAccuracy: true
				},
				trackUserLocation: true
			});
			self.map.addControl(self.geoLocation.control, 'top-right');
		}
	},
	showLocation: function (location, flyto) {
		/* showLocation: displays location on map.
		 * 
		 * Pars: location - the location itself.
		 * 
		 *       flyto - a bool that determines 
		 *               whether to flyto the locale.
		 * */

		/* Step 1: 
		 * Change position of map 
		 * */
		var self = this;
		self.map.setFilter('theBordersActive', ['==', 'id', location]);
		if (flyto) {
			if (self.collection.get(location).get('geooutline')) {
				/* If it's a building, find the northeast and southwest coords
					of the area the screen should zoom into, 
					based on the dimensions of the building's geoutline.
				*/
				var coordinates = self.collection.get(location).get('geooutline').map(function (cords) {
					return [cords.lng, cords.lat];
				});
				var bounds = coordinates.reduce(function (bounds, coord) {
					return bounds.extend(coord);
				}, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
				self.map.fitBounds(bounds, {
					padding: self.fbPadding,
					offset: self.fbOffset,
				});
			} else {
				/* If it's not a building, it will only have one coordinate.
				   Find that point, then create an 2-el array 
				   based on that point.
				   One point rep's the NE corner of the bounding box,
				   while the other marks the SW corner.
				*/
				position = self.collection.get(location).get('location');
				var theSpot = [+position.longitude, +position.latitude];
				var northEast = [theSpot[0] - 0.0001, theSpot[1] - 0.0001];
				var southWest = [theSpot[0] + 0.0001, theSpot[1] + 0.0001];
				var bounds = new mapboxgl.LngLatBounds(northEast, southWest);
				self.map.fitBounds(bounds, {
					padding: self.fbPadding,
					offset: self.fbOffset,
				});
			}
		}
		/* Step 2: 
		 * Change HTML of location panel
		 * */
		// reset the info body
		self.$infoBody.html("");

		// fill in the info header and body with new location content
		self.showDesHead(location);
		//self.showDirBtn(location);
		self.showDescription(location);
		self.showOffices(location);
		self.showDepts(location);
		self.showYouVisit(location);

		// log the new location as the current one
		self.curLocation = location;
		// switch the window to display details
		self.windowSwitcher('details');
	},
	/*
	showDirectionsPanel: function(dirFromID){
		var self = this;
		console.log(dirFromID);
		if (!self.$el.hasClass("show-directions")) {
			self.windowSwitcher('directions');
		}
		if (dirFromID && dirFromID != '') {
			dirFromInp.value = self.collection.get(dirFromID).get('name');
		}
	},
	*/

	/* This section of the CampusMap obj 
	 * is exclusively for the methods
	 * that format the location and direction HTML
	 * */

	// location department info
	showDepts: function (location) {
		var self = this;
		var theDepts = [];
		_.each(self.depts.models, function (obj) {
			if (obj.has("building") && obj.get("building") == location) {
				theDepts.push(self.deptHTML(obj));
			}
		});
		if (theDepts.length <= 0) {
			return;
		}
		// sort departments by school id
		theDepts = _.sortBy(theDepts, 'name');
		theDepts = _.sortBy(theDepts, 'id');

		var theHTML = document.createElement('div');
		theHTML.setAttribute('class', 'map-menu-body-depts');
		var deptHeader = document.createElement('h3');
		deptHeader.innerText = "Departments";
		theHTML.appendChild(deptHeader);

		var htmlMade = false;
		var theCounter = theDepts.length;
		var i = 0;
		while (theCounter && i < s_priority.length) {
			//console.log(i);
			var foundOne = false;
			for (j = 0; j < theDepts.length; j++) {
				//console.log(j)
				if (s_priority[i] == theDepts[j].sID) {
					//console.log(s_priority[i] + "vs" + theDepts[j].sID)
					if (!foundOne) {
						var schoolHeader = document.createElement('h4');
						schoolHeader.innerText = theDepts[j].sName;
						foundOne = true;
						theHTML.appendChild(schoolHeader);
					}
					//console.log(theDepts[j].html);
					theHTML.appendChild(theDepts[j].html);
					theCounter--;
					if (!htmlMade) {
						htmlMade = true;
					}
				}
			}
			i++;
		}
		self.$infoBody.append(theHTML);
	},
	// location header info
	showDesHead: function (location) {
		var self = this;

		// change header to be title
		self.$infoHeader.text(HTMLParser(self.collection.get(location).get('name')));

		// create html for other parts of header (img and back btn)
		var theHTML = "" +
			// img
			((self.collection.get(location).get('image') != false) ? '<img src="' + self.collection.get(location).get('image') + '" />' : '') +
			// back button
			"<button id='backToMain'>Show all locations</button>";

		//console.log(theHTML);
		// append the des header
		self.$infoBody.append(theHTML);
	},
	// location description
	showDescription: function (location) {
		var self = this;

		// create the HTML
		var theHTML = "" +
			// location des body
			((self.collection.get(location).has('description')) ? self.collection.get(location).get('description') : '');

		// append the description
		self.$infoBody.append(theHTML);

	},
	// location's direction button

	/*
	showDirBtn: function(location){
		var self = this;

		// create div that holds direction button
		var dirDiv = document.createElement('div');

		// create h3 for btn section, then append to div
		var dirHead = document.createElement('h3');
		dirHead.innerText = "Directions";
		dirDiv.appendChild(dirHead);

		// create direction btn, then append to div
		var dirBtn = document.createElement('button');
		dirBtn.setAttribute('id', 'dirBtn');
		dirBtn.setAttribute('data-loc', self.collection.get(location).get('id'));
		dirBtn.innerText = "Get Directions";
		dirDiv.appendChild(dirBtn);
		
		// return the div with header and btn
		self.$infoBody.append(dirDiv);
	},
	*/
	// location's office section
	showOffices: function (location) {
		var self = this;
		var theOffices = [];
		_.each(self.offices.models, function (obj) {
			if (obj.has("building") && obj.get("building") == location) {
				theOffices.push(self.officeHTML(obj));
			}
		});
		if (theOffices.length <= 0) {
			return;
		}
		// sort Offices by priority
		theOffices = _.sortBy(theOffices, 'name');
		theOffices = _.sortBy(theOffices, 'priority');

		// Cycle through each office and append to a main div
		var mainDiv = document.createElement('div');
		mainDiv.setAttribute('class', 'map-menu-body-offices');

		var officeHeader = document.createElement('h3');
		officeHeader.innerHTML = 'Offices &amp; Services';
		mainDiv.appendChild(officeHeader);

		for (var i = 0; i < theOffices.length; i++) {
			mainDiv.appendChild(theOffices[i].html);
		}
		self.$infoBody.append(mainDiv);
	},
	// location's youVisit link
	showYouVisit: function (location) {
		var self = this;
		// test if we can get an youvisit href. if not, stop function
		var yvHref;
		yvHref = self.collection.get(location).get('youvisit').trim();
		if (yvHref == "") {
			return;
		}

		// create div for you visit
		var yvDiv = document.createElement('div');
		yvDiv.setAttribute('class', 'map-menu-body-youvisit');

		// create
		var yvHeading = document.createElement('h3');
		yvHeading.innerText = 'Virtual Tour';

		// create 
		var yvLink = document.createElement('a');
		yvLink.setAttribute('href', yvHref);
		yvLink.setAttribute('target', '_blank');

		// create
		var yvImg = document.createElement('img');
		yvImg.setAttribute('src', stylesheetDir + '/dist/img/youvisit.jpg');

		// nest the children proper
		yvLink.appendChild(yvImg);
		yvDiv.appendChild(yvHeading);
		yvDiv.appendChild(yvLink);

		// append the div
		self.$infoBody.append(yvDiv);
	},

	/* This section of code is exclusively
	 * for methods that support other display methods
	 * */

	// Builds HTML for showDepts
	deptHTML: function (obj) {
		var theLink = document.createElement('a');
		theLink.innerText = obj.get('title').rendered;
		theLink.setAttribute('href', obj.get('link'));
		theLink.setAttribute('target', '_blank');

		// For now, we're only saving one school. 
		// But if MU adds a multi school dept, start with this code:
		// var theID = [];
		// _.each(obj.get('schools'), function(innerO){
		// 	theIDs.push(innerO.term_id);
		// })
		return {
			html: theLink,
			name: theLink.innerText,
			sID: obj.get('schools')[0].term_id,
			sName: obj.get('schools')[0].name
		};
	},
	// builds HTML for showOffices
	officeHTML: function (obj) {
		// holds the office/service
		var theDiv = document.createElement('div');
		theDiv.setAttribute('class', 'office');

		// link to office/service
		var theOffice;
		if (obj.has('link')) {
			theOffice = document.createElement('a');
			theOffice.setAttribute('href', obj.get('link'));
			theOffice.setAttribute('target', '_blank');
			theOffice.setAttribute('class', 'officeText link');
			theOffice.innerText = obj.get('title').rendered;
		} else {
			theOffice = document.createElement('p');
			theOffice.innerText = obj.get('title').rendered;
			theOffice.setAttribute('class', 'officeText');
		}
		var theOfficeTitle = document.createElement('h4');
		theOfficeTitle.innerText = obj.get('title').rendered;

		// theOffice.appendChild(theOfficeTitle);		

		// make a room/area p-tag if office has one
		var theRoom = false;
		// if (obj.has('room')) {
		// 	theRoom = document.createElement('p');
		// 	theRoom.innerHTML = '&ndash;' + obj.get('room');
		// }
		// combine everything into the div
		theDiv.appendChild(theOffice);
		if (theRoom) {
			theDiv.appendChild(theRoom);
		}
		return {
			html: theDiv,
			name: theOfficeTitle.innerText,
			priority: obj.get('priority') ? obj.get('priority') : 9999,
		};
	},

	/* This section is for methods that aid 
	 * the directions portion of the map
	 * */

	/*
	   clickDirBtn: function(ev){
		   var self = this;
		   if (ev){
			   var location = ev.target.getAttribute('data-loc');
			   mapapp.navigate("directions/" + location, {
				   trigger: true
			   });
		   	
		   }
		   else {
			   mapapp.navigate("directions/", {
				   trigger: true
			   });
		   }
	   },

   */

	/*
	 *
	 * */
	/*
	displayDirections: function(dirFromID, dirToID) {
		var self = this;
		if (dirFromInp.value.trim() == "") {
			dirFromInp.value = self.collection.get(dirFromID).get('name');
		}
		if (dirToInp.value.trim() == "") {
			dirToInp.value = self.collection.get(dirToID).get('name');
		}
		// set the orig/dest of the map's directions prop to the proper post IDs
		self.directions.orig = self.collection.findWhere({'id': dirFromID}).get('p_id');
		console.log(self.collection.find('id', dirFromID));
		self.directions.dest = self.collection.findWhere({'id': dirToID}).get('p_id');
		// run the display method of the map's direction property
		self.directions.getDirections();
	},
	*/

	/*
	clickDirSearch: function() {
		var self = this;

		// grab location names from direction input vals
		var dirFromName = dirFromInp.value.trim();
		var dirToName = dirToInp.value.trim();

		// find models associated with names
		var fromModel = self.collection.findWhere({'name': dirFromName});
		var toModel = self.collection.findWhere({'name': dirToName});

		// Grab IDs from models
		var fromID, toID;
		if (!fromModel || !toModel){
			// If function can't find a model, stop it
			console.log("Not happening");
			return;
		}
		else {
			fromID = fromModel.get('id');
			toID = toModel.get('id');
		}
		// grab the IDs
		mapapp.navigate("directions/" + fromID + "/" + toID, {trigger: true});
	},
	*/

	/*
	clickDirSwitchBtn: function(){
		var self = this;

		var toVal = dirToInp.value;
		dirToInp.value = dirFromInp.value;
		dirFromInp.value = toVal;
	},
	*/

	/*
	goBackFromDir: function(e, self) {
		// switch window to last place
		console.log(self.windows);
		self.windowSwitcher(self.windows.last);
	},
	*/

	// switch out the windows
	windowSwitcher: function (newWindow) {
		self = this;
		// record the prior modal window and state the current one
		self.windows.last = self.windows.current;
		self.windows.current = newWindow;

		// switch the classes to make the window visible
		switch (self.windows.current) {
			// if it's the main window, we remove whatever show class we had.
			case "main":
				// hide details window if moving back from directions
				if (self.windows.last == "directions") {
					self.$el.addClass('locsAndDirs');
				}
				self.$el.removeClass('show-' + self.windows.last);
				mapapp.navigate("//", {
					replace: true,
					trigger: false
				});
				break;
				// if it's the details, we remove the last class and add the new one
			case "details":
				self.$el.removeClass('locsAndDirs');
				self.$el.removeClass('show-' + self.windows.last);
				self.$el.addClass('show-' + self.windows.current);
				// if the last location wasn't main, we need to change the href
				if (self.windows.last != "main") {
					mapapp.navigate("location/" + self.curLocation, {
						trigger: false
					});
				}
				break;
				// if it's the directions, we remove the last class and add the new one
			case "directions":
				// if the last window was main, hide location details;
				if (self.windows.last == "main") {
					self.$el.addClass('locsAndDirs');
				}
				self.$el.removeClass('show-' + self.windows.last);
				self.$el.addClass('show-' + self.windows.current);
				break;
		}
	}
});
campusmap = new CampusMap();


/* *
 * Sec.D: The Map's Router
 * */

/* Router
 ********************************************************** */
var MapApp = Backbone.Router.extend({
	$hidden: jQuery("article .hidden"),
	routes: {
		//show a specific location
		"location/:location": "showLoc",
		"building=:location": "showLoc",
		// "directions": "showDir",
		// "directions/:dirFrom": "showDir",
		//show some directions
		// "directions/:dirFrom/:dirTo": "getDir"
	},
	initialize: function () {
		var self = this;
		campusmap.render();
		campusmap.map.on('load', function () {
			self.startHistory();
		});
	},
	startHistory: function () {
		Backbone.history.start();
	},
	showLoc: function (location) {
		// mapbox's isStyleLoaded stops firing in web inspector, presumably in ios.
		// if (campusmap.map.isStyleLoaded()){
		campusmap.showLocation(location, true);
		//}
		//else {
		campusmap.map.on('style.load', function () {
			campusmap.showLocation(location, true);
		});
		//}		
	},
	/*
	getDir: function(dirFromID, dirToID){
		campusmap.showDirectionsPanel();
		campusmap.displayDirections(dirFromID, dirToID);
	},
	showDir: function(dirFromID){
		if (dirFromID) {
			campusmap.showDirectionsPanel(dirFromID);
		}
		else {
			campusmap.showDirectionsPanel();
		}
	}
	*/
});
var mapapp = new MapApp();


/* *
 * Sec.E: Event Handlers
 * */

// Fetch the locations and offices. When that's done, render the map
jQuery(function () {
	b4Resizer();
	if (campusmap.isMobile()) {
		scrolledUp = false;
	}
	// search for locations whenever user types into search bar
	searchInp.onkeyup = campusmap.displayResults;
	// clear search results when user clicks the clear button
	clearBtn.onclick = campusmap.clearResults;

	/* Scenario 1: User clicks on a location in the sidebar
	 * 		Effects: - Scrolls menu up to 40% of window on mobile
	 * */
	jQuery(document).on('click', '.sidebarSel', function () {
		// first, if menu is affixed, unaffix it
		if (hasClass(mapMenu, 'affixed')) {
			removeClass(mapMenu, 'affixed');
			document.body.scrollTop = window.innerHeight - 153;
			document.documentElement.scrollTop = window.innerHeight - 153;
		}
		// grab where scroll will end and set offset accordingly
		var wScroll = window.innerHeight * 0.4;
		campusmap.setBoundingOffset(wScroll);
		// scroll to pos and display building
		if (campusmap.isMobile()) {
			jQuery('html, body').animate({
				scrollTop: wScroll
			}, 800);
		}
		//return false;
	});

	/* Scenario 2: User clicks dir btn
	 */
	// jQuery(document).on('click', '#dirBtn', function(e){
	// 	campusmap.clickDirBtn(e.target.getAttribute('data-loc'));
	// })
	/* Scenario 3: User clicks dir btn
	 */
	/*
	document.getElementById('dirBack').onclick = function(e){
		campusmap.goBackFromDir(e, campusmap)
	};
	*/

	/* Scenario 4: User scrolls the map
	 *		Effects: - Determines whether to affix map menu to header.
	 *				 - This happens if browser is at mobile width
	 *				   and user has scrolled the map off the screen
	 *				 - Will unaffix menu if map gets scrolled back down.	
	 * */
	document.onscroll = function (e) {
		b4Resizer();
		if (campusmap.isMobile()) {
			var rect = mapMenu.getBoundingClientRect();
			var mapCanvasHeight = rect.height - 113;
			var scrollTop = window.pageYOffset;
			if (rect.top <= 60) {
				if (!hasClass(mapMenu, 'affixed')) {
					addClass(mapMenu, 'affixed');
				} else if (scrollTop < 60) {
					removeClass(mapMenu, 'affixed');
					document.body.scrollTop = window.innerHeight - 153;
					document.documentElement.scrollTop = window.innerHeight - 153;
				}
			}
		}
	};
	/* Scenario 3: User resizes the window
	 */
	window.onresize = function (e) {
		b4Resizer();
		//campusmap.directionTest();
		if (!scrolledUp && !campusmap.isMobile()) {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
			scrolledUp = true;
		} else if (scrolledUp && campusmap.isMobile()) {
			scrolledUp = false;
		}
		mobileMenuHandling();
		campusmap.map.resize();
	};
});

// Inject CSS into the Tooltip style tag
function cssInject(rule) {
	document.getElementById("mapScrollStyle").innerHTML = rule;
}

function b4Resizer() {
	// change before element height to match nav
	// height of navbar
	navHeight = document.getElementsByClassName('header')[0].clientHeight;
	rule = "div.content-holder:before{ height: " + navHeight + "px;}";
	// deactiveate for now
	//cssInject(rule);
}

// determine if on iOS, and change style as needed
function mobileMenuHandling() {
	// only resize if innerWidth changed (android only)
	var noChange = false;
	if (window.innerWidth == oldWidth) {
		noChange = true;
	}
	oldWidth = window.innerWidth;

	// check whether we are on ios safari
	var ua = window.navigator.userAgent;
	var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	var safari = !!ua.match(/Version\/[\d\.]+.*Safari/i);
	var iOSSafari = iOS && safari;

	// create the rule to inject (or inject blank and remove existing rule for desktop)
	var innerHeight = window.innerHeight;
	var rule;
	if (iOSSafari) {
		rule = "div.map-container-canvas{ height: calc(" + oldHeight + "px - 112px) } div.map-menu{ height: calc(" + innerHeight + "px - 60px) }";
	} else {
		if (noChange) {
			return;
		}
		rule = "div.map-container-canvas{ height: calc(" + innerHeight + "px - 112px) } div.map-menu{ height: calc(" + innerHeight + "px - 60px) }";
	}
	if (window.innerWidth < 768) {
		cssInject(rule);
	} else {
		cssInject("");
	}
}
mobileMenuHandling();